// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GameControllerBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22 14.5h-3a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 1 1 0 3Zm-9-3h-.5V11a1.5 1.5 0 1 0-3 0v.5H9a1.5 1.5 0 1 0 0 3h.5v.5a1.5 1.5 0 0 0 3 0v-.5h.5a1.5 1.5 0 1 0 0-3Zm17.595 13.867a5 5 0 0 1-7.625.67.826.826 0 0 1-.066-.07l-4.82-5.467h-4.168l-4.815 5.466a5 5 0 0 1-8.524-4.335v-.025L2.626 11.1a7.985 7.985 0 0 1 7.86-6.599H21.5a8.01 8.01 0 0 1 7.866 6.56v.024l2.045 10.521a.26.26 0 0 1 0 .025 4.966 4.966 0 0 1-.816 3.738ZM21.5 17.5a5 5 0 1 0 0-10H10.486a4.988 4.988 0 0 0-4.909 4.133v.026l-2.042 10.5a2 2 0 0 0 3.357 1.779l5.22-5.93a1.5 1.5 0 0 1 1.126-.508H21.5Zm6.97 4.664-.875-4.494a7.98 7.98 0 0 1-5.534 2.807l3.052 3.465a2 2 0 0 0 3.356-1.778h.001Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
